import { render, staticRenderFns } from "./ChatHistoryHeader.vue?vue&type=template&id=450b3345&"
import script from "./ChatHistoryHeader.vue?vue&type=script&lang=js&"
export * from "./ChatHistoryHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports